export default __webpack_public_path__ + "static/media/pending.7d412923.svg";